import Firm from '@/models/firm';
import Api from '@/services/api';

class FirmApi {
    getCurrentFirm(onSuccess: (firm: Firm) => void) {
        return Api.callApi({ url: `/api/v1/firm`, onSuccess });
    }
}

export default new FirmApi();